module.exports = __webpack_public_path__ + "static/media/riddhi_tharewal.f6718c4b.jpg";